export default __webpack_public_path__ + "static/media/bg_romulus_small.1dc71cb5.svg";